import styled from '@mui/system/styled';

export const ContentCnt = styled('div')({
  width: 'auto', // Allow for dynamic width based on content
  minWidth: '450px',
  maxWidth: '650px',
  maxHeight: '85vh',
  overflow: 'auto',
  '& label': {
    padding: 0,
    margin: 0,
    '& .content': {
      fontSize: 13,
    },
  },
  // Custom scrollbar styling
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#a1a1a1',
  },
});
